import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { BaseFilterProps } from "../types";

/**
 * Date filter component.
 * Renders date-based filter options with checkboxes.
 * Can be extended to include date pickers or date range selectors.
 */
export function DateFilter({
  filter,
  config,
  onValueChange,
}: Omit<BaseFilterProps, 'isActive' | 'onToggle' | 'onRemove'>) {
  // For now, uses the same checkbox pattern as other filters
  // Can be enhanced with date picker functionality in the future
  return (
    <>
      {config.options?.map((option) => (
        <label
          key={option.value}
          className="flex items-center gap-2 cursor-pointer hover:bg-muted p-2 rounded"
        >
          <Checkbox
            checked={filter.values.includes(option.value)}
            onCheckedChange={() => onValueChange(option.value)}
          />
          <span className="text-sm">{option.label}</span>
        </label>
      ))}
    </>
  );
}

export default DateFilter;

